
ko.bindingHandlers.console = {
    init: function (element, valueAccessor, allBindings, viewModel, context) {
        //console.log('CLOG', ko.unwrap(valueAccessor()));
    },
    update: function (element, valueAccessor, allBindings, viewModel, context) {
        console.log('CLOG', ko.unwrap(valueAccessor()));
    }
};